import React, { useState, useEffect, useRef, useMemo } from "react"
import { FiFilter } from "react-icons/fi"
import Badge from "../../../../../components/badge/badge"
import { getApiInstance } from "../../../../../utils/api"
import Button from "../../../../../components/button/button"
import Table from "../../../../../components/table/table"
import Notification from "../../../../../components/notification/notification"
import { IoReturnUpBackOutline } from "react-icons/io5"
import { PiClock, PiRocket } from "react-icons/pi"
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch"
import Modal from "../../../../../components/modal/modal"
import Accordion from "../../../../../components/accordion/accordion"
import Tag from "../../../../../components/tag/tag"
import ImageRenderer from "../../../../../components/ImageRender/ImageRender"
import Popup from "../../../../../components/popup/popup"
import InputDropdownAdd from "../../../../../components/inputs/inputDropdownAdd/inputDropdownAdd"
import InputCheckbox from "../../../../../components/inputs/inputCheckbox/inputCheckbox"
import Input from "../../../../../components/inputs/input/input"
import Calendar from "../../../../../components/calendar/Calendar"
import { matchesSearchInValues } from "../../../../../utils/searchUtils"

const estadoLabels = {
	Publicado: "Publicado",
	EnEdicion: "En edición",
	Archivado: "Archivado",
	PendienteDeAprobacion: "Pendiente de aprobación",
	ListoParaPublicar: "Listo para publicar"
}

const familiaMapping = {
	1: "Mobiliario Central",
	2: "Mobiliario Perimetral",
	3: "Mesas",
	4: "Probadores",
	5: "Caja",
	6: "Dotación",
	7: "Instalaciones",
	8: "Señalética",
	9: "BOH",
	10: "Detalles constructivos",
11: "Detalles instalaciones",
12: "Montaje de mobiliario",
}
const categoriasMapping = {
	1: "Tiendas Top",
	2: "Tiendas Light",
	3: "Tiendas Low",
	4: "General",
	5: "Banners",
	6: "Señalización",
	7: "Positive Store",
	8: "Make Up 400",
	9: "Munich",
	10: "Copenhague",
	11: "Miami-Splau",
	12: "Make Up 400 PLUS",
}

const estados = [
	"Publicado",
	"En edición",
	"Archivado",
	"Pendiente de aprobación",
	"Listo para publicar",
	"Sin estado"
]

const estadoDefault = "Sin estado"

const columnsConEstado = [
	{
		key: "rutaImagen",
		label: "Miniatura",
		render: (row) => (
			<ImageRenderer
				thumbnail={row.rutaImagen}
				alt={row.nombreBook || "Sin nombre"}
			/>
		)
	},
	{ key: "nombreBook", label: "Nombre", className: "col-nombre" },
	{ key: "referencia", label: "Referencia" },
	{ key: "nombreFamilia", label: "Familia" },
	{
		key: "variante",
		label: "Variante",
		render: (row) => row.variante || "N/A"
	},
	{
		key: "nombreFamilia",
		label: "Categoría",
		render: (row) => familiaMapping[row.codFamilia] || "N/A"
	},
	{
		key: "codCategorias",
		label: "Imagen",
		render: (row) => {
			if (Array.isArray(row.categorias) && row.categorias.length > 0) {
				return row.categorias
					.map((categoria) => categoriasMapping[categoria] || categoria)
					.join(", ")
			} else {
				return "Sin categorías"
			}
		}
	},
	{ key: "medida", label: "Unidad de medida" },
	{
		key: "estado",
		label: "Estado",
		render: (row) => {
			let variant
			const estadoLegible = estadoLabels[row.estado] || "Sin estado"

			switch (row.estado) {
				case "Publicado":
					variant = "success"
					break
				case "EnEdicion":
					variant = "warning"
					break
				case "Archivado":
					variant = "info"
					break
				case "PendienteDeAprobacion":
					variant = "info"
					break
				case "ListoParaPublicar":
					variant = "success"
					break
				default:
					variant = "default"
			}

			return <Badge label={estadoLegible} variant={variant} />
		}
	}
]

export default function ListoParaDesplegar() {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [muebles, setMuebles] = useState([])
	const [searchTerm, setSearchTerm] = useState("")
	const [selectedMuebles, setSelectedMuebles] = useState([])
	const [filterVariantes, setFilterVariantes] = useState([])
	const [filterCategoria, setFilterCategorias] = useState([])
	const [filterSubcategoria, setFilterSubcategoria] = useState([])
	const [filterEstado, setFilterEstado] = useState([])
	const [variantes, setVariantes] = useState([])
	const [subCategorias, setSubcategorias] = useState([])
	const [categorias, setCategorias] = useState([])
	const [familias, setFamilias] = useState([])
	const [filterFamilia, setFilterFamilia] = useState([])
	const [user, setUser] = useState(null)
	const [isPopupSolicitarTarifasOpen, setIsPopupSolicitarTarifasOpen] =
		useState(false)
	const [
		isPopupSolicitarTarifasQuestionOpen,
		setIsPopupSolicitarTarifasQuestionOpen
	] = useState(false)
	const [proveedores, setProveedores] = useState([])
	const [selectedProveedores, setSelectedProveedores] = useState([])
	const [nombreTarifa, setNombreTarifa] = useState("")
	const [tarifas, setTarifas] = useState([])
	const [plazo, setPlazo] = useState(15)
	const [mueblesNuevos, setMueblesNuevos] = useState([])
	const [isPopupProgramarDespliegueOpen, setIsPopupProgramarDespliegueOpen] =
		useState(false)
	const [scheduledDate, setScheduledDate] = useState("")
	const [despliegueTipo, setDespliegueTipo] = useState("")

	const notificationRef = useRef(null)

	const api = getApiInstance()

	useEffect(() => {
		const fetchUser = async () => {
			try {
				const api = getApiInstance()
				const response = await api.get("/api/Usuario/GetCurrentUser")
				setUser(response.data)
			} catch (error) {
				console.error("Error al obtener el usuario:", error)
			}
		}

		fetchUser()
	}, [])

	const fetchMuebles = async () => {
		try {
			const response = await api.get("/api/Mueble/GetListosParaPublicar")
			console.log("Datos de muebles recibidos:", response.data)
			setMuebles(response.data)
		} catch (error) {
			console.error("Error fetching muebles:", error)
			setMuebles([])
		}
	}

	const fetchProveedores = async () => {
		try {
			const response = await api.get("/api/Empresa/GetAllEmpresas")
			const proveedoresFiltrados =
				response.data?.filter(
					(empresa) => empresa.tipoEmpresa === "Proveedor"
				) || []

			setProveedores(proveedoresFiltrados)
			setSelectedProveedores(
				proveedoresFiltrados.map((proveedor) => proveedor.codEmpresa)
			)
		} catch (error) {
			console.error("Error al obtener los proveedores:", error)
			setProveedores([])
		}
	}

	const fetchTarifas = async () => {
		try {
			const response = await api.get("/api/MueblesPrecios/Tarifas")

			setTarifas(
				response.data.map((tarifa) => ({
					label: tarifa,
					value: tarifa
				}))
			)
		} catch (error) {
			console.error("Error al obtener los proveedores:", error)
			setTarifas([])
		}
	}

	useEffect(() => {
		fetchMuebles()
		fetchProveedores()
		fetchTarifas()
	}, [])

	useEffect(() => {
		const allVariantes = muebles
			.map((product) => product.variante) // Extraer variantes de cada producto
			.flat() // Aplanar el array (porque variantes es un array dentro de cada producto)
			.filter((value, index, self) => self.indexOf(value) === index) // Filtrar duplicados

		// Filtrar subcategorías sin duplicados
		const allSubcategorias = muebles
			.map((product) => product.categorias)
			.flat()
			.filter((value, index, self) => self.indexOf(value) === index)

		// Filtrar categorías sin duplicados
		const allCategorias = muebles
			.map((product) => familiaMapping[product.codFamilia])
			.filter((value, index, self) => self.indexOf(value) === index)

		const allFamilias = muebles
			.map((product) => product.nombreFamilia)
			.filter(
				(value, index, self) => self.indexOf(value) === index && value != null
			) // Filtrar duplicados

		// Actualizar el estado
		setVariantes(allVariantes)
		setSubcategorias(allSubcategorias)
		setCategorias(allCategorias)
		setFamilias(allFamilias)
	}, [muebles])

	// Filtrar y ordenar muebles
	const filteredMuebles = useMemo(() => {
		let filtered = muebles.filter(
			(mueble) =>
				matchesSearchInValues(
					[mueble.nombreBook, mueble.referencia],
					searchTerm
				)
		)

		return filtered
			.filter(
				(product) =>
					filterVariantes.length === 0 ||
					filterVariantes.includes(product.variante)
			)
			.filter(
				(product) =>
					filterCategoria.length === 0 ||
					filterCategoria.includes(familiaMapping[product.codFamilia])
			)
			.filter(
				(product) =>
					filterSubcategoria.length === 0 ||
					product.categorias.some((categoria) =>
						filterSubcategoria.includes(categoria)
					)
			)
			.filter((product) => {
				const estadoActual = estados.includes(product.estado)
					? product.estado
					: estadoDefault
				return filterEstado.length === 0 || filterEstado.includes(estadoActual)
			})
			.filter(
				(product) =>
					filterFamilia.length === 0 ||
					filterFamilia.includes(product.nombreFamilia)
			)
	}, [
		searchTerm,
		muebles,
		filterVariantes,
		filterCategoria,
		filterSubcategoria,
		filterEstado,
		filterFamilia
	])

	const handleSelectMueble = (muebleId) => {
		setSelectedMuebles((prevSelectedMuebles) => {
			const isSelected = prevSelectedMuebles.includes(muebleId)
			if (isSelected) {
				return prevSelectedMuebles.filter((id) => id !== muebleId)
			} else {
				return [...prevSelectedMuebles, muebleId]
			}
		})
	}

	const handleDevolverABorrador = async (row) => {
		try {
			const requestBody = [row.codMueble]

			await api.patch(`/api/Mueble/DevolverABorradores`, requestBody, {
				headers: {
					"Content-Type": "application/json"
				}
			})

			await fetchMuebles()
			await fetchMueblesListos()

			notificationRef.current.addNotification(
				"El mueble ha sido devuelto a borradores exitosamente.",
				"success"
			)
		} catch (error) {
			console.error("Error devolviendo el mueble a borradores:", error)
			notificationRef.current.addNotification(
				"Error al devolver el mueble a borradores.",
				"error"
			)
		}
	}

	const fetchMueblesListos = async () => {
		try {
			const response = await api.get("/api/Mueble/GetListosParaPublicar")
			console.log("Muebles recibidos:", response.data)

			if (response.data && Array.isArray(response.data)) {
				setMuebles(response.data)
			} else {
				setMuebles([])
				console.warn("Datos inválidos recibidos")
			}
		} catch (error) {
			console.error("Error fetching muebles listos para desplegar", error)
			setMuebles([])
		}
	}

	const handleDesplegarVersion = async () => {
		if (selectedMuebles.length === 0) {
			notificationRef.current.addNotification(
				"Selecciona al menos un mueble para desplegar.",
				"warning"
			)
			return
		}

		const mueblesNuevos = muebles
			.filter((mueble) => selectedMuebles.flat().includes(mueble.codMueble))
			.filter((mueble) => mueble.estadoModificacion === 4)

		setMueblesNuevos(mueblesNuevos)

		if (mueblesNuevos.length > 0) {
			setIsPopupSolicitarTarifasQuestionOpen(true)
		} else {
			publicarMuebles()
		}
	}

	const publicarMuebles = async (isMueblesNuevosEmpty) => {
		try {
			const payload = {
				codMuebles: selectedMuebles.flat(),
				codMueblesNuevos: isMueblesNuevosEmpty ? [] : mueblesNuevos.map((mueble) => mueble.codMueble),
				codsProveedor: selectedProveedores,
				plazo: plazo || 15,
				nombreTarifa: nombreTarifa
			}

			const response = await api.patch("/api/Mueble/PublicarMuebles", payload, {
				headers: {
					"Content-Type": "application/json"
				}
			})

			console.log("Muebles desplegados correctamente:", response)

			await fetchMueblesListos()
			setSelectedMuebles([])

			notificationRef.current.addNotification(
				"Muebles desplegados correctamente.",
				"success"
			)
			//Notifica a todos los usuarios
			if (user) {
				const formData = new FormData()
				formData.append("DestinatariosNotificacion", 2) // Todos
				formData.append("CodUsuarioNotifica", user.codUsuario)
				formData.append(
					"Mensaje",
					`Se ha publicado una nueva versión del book.`
				)
				formData.append("Titulo", "Nueva versión publicada")
				formData.append("TipoNotificacion", 0)
				formData.append("Enlace", "/versions")

				await api.post("/api/Notificaciones", formData)
			}
		} catch (error) {
			console.error("Error al desplegar los muebles", error)
			notificationRef.current.addNotification(
				"Error al desplegar los muebles. Revisa la consola para más detalles.",
				"error"
			)
		}
	}

	const actionsListoParaDesplegar = (row) => [
		{
			label: "Devolver a borrador",
			onClick: () => handleDevolverABorrador(row),
			icon: <IoReturnUpBackOutline />
		}
	]

	const openModal = () => {
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
	}

	const handleAcceptFilters = () => {
		closeModal()
	}

	const handleCleanFilter = () => {
		setFilterVariantes([])
		setFilterCategorias([])
		setFilterSubcategoria([])
		setFilterEstado([])
		setFilterFamilia([])
	}

	const handleSelectVariante = (varianteName) => {
		setFilterVariantes((prevSelected) => {
			// Verificar si la variante ya está en la lista
			if (prevSelected.includes(varianteName)) {
				// Si ya está en la lista, eliminarla
				return prevSelected.filter((variante) => variante !== varianteName)
			} else {
				// Si no está, agregarla
				return [...prevSelected, varianteName]
			}
		})
	}

	const handleSelectCategoria = (categoriaName) => {
		setFilterCategorias((prevSelected) => {
			// Verificar si la categoria ya está en la lista
			if (prevSelected.includes(categoriaName)) {
				// Si ya está en la lista, eliminarla
				return prevSelected.filter((categoria) => categoria !== categoriaName)
			} else {
				// Si no está, agregarla
				return [...prevSelected, categoriaName]
			}
		})
	}

	const handleSelectSubcategoria = (subcategoriaName) => {
		setFilterSubcategoria((prevSelected) => {
			// Verificar si la subcategoria ya está en la lista
			if (prevSelected.includes(subcategoriaName)) {
				// Si ya está en la lista, eliminarla
				return prevSelected.filter(
					(subcategoria) => subcategoria !== subcategoriaName
				)
			} else {
				// Si no está, agregarla
				return [...prevSelected, subcategoriaName]
			}
		})
	}

	const handleSelectFamilia = (familiaName) => {
		setFilterFamilia((prevSelected) => {
			// Verificar si la familia ya está en la lista
			if (prevSelected.includes(familiaName)) {
				// Si ya está en la lista, eliminarla
				return prevSelected.filter((familia) => familia !== familiaName)
			} else {
				// Si no está, agregarla
				return [...prevSelected, familiaName]
			}
		})
	}

	const handleSelectEstado = (estadoName) => {
		setFilterEstado((prevSelected) => {
			// Verificar si el estado ya está en la lista
			if (prevSelected.includes(estadoName)) {
				// Si ya está en la lista, eliminarla
				return prevSelected.filter((estado) => estado !== estadoName)
			} else {
				// Si no está, agregarla
				return [...prevSelected, estadoName]
			}
		})
	}

	const handleConfirmSolicitarTarifa = () => {
		if (despliegueTipo === "programar") {
			setIsPopupProgramarDespliegueOpen(true)
		} else {
			publicarMuebles()
		}
		setIsPopupSolicitarTarifasQuestionOpen(false)
		setIsPopupSolicitarTarifasOpen(false)
	}

	const handleSetNombreTarifa = (e, type = "select") => {
		// 1) Selección de un elemento existente: tipo "select"
		if (type === "select") {
			setNombreTarifa(e) // no cambiamos nada
			return
		}

		// 3) Añadir uno nuevo: tipo "add"
		if (type === "add") {
			// formatear fecha actual YYYYMMDD
			const fecha = new Date().toISOString().slice(0, 10).replace(/-/g, "")
			if (e.endsWith("_")) {
				e = e.slice(0, -1).split("_")[0]
			}
			const newName = `${e}_${fecha}`

			// 3a) Actualizamos el dropdown (suponiendo que tarifas viene de un state)
			setTarifas((old) => [...old, { label: newName, value: newName }])

			// 3b) Seleccionamos ese nuevo
			setNombreTarifa(newName)
			return
		}
	}

	const handleProveedorChange = (codEmpresa) => {
		setSelectedProveedores((prev) =>
			prev.includes(codEmpresa)
				? prev.filter((id) => id !== codEmpresa)
				: [...prev, codEmpresa]
		)
	}

	const handleProgramarDespliegue = () => {
        		if (selectedMuebles.length === 0) {
			notificationRef.current.addNotification(
				"Selecciona al menos un mueble para desplegar.",
				"warning"
			)
			return
		}

        const mueblesNuevos = muebles
			.filter((mueble) => selectedMuebles.flat().includes(mueble.codMueble))
			.filter((mueble) => mueble.estadoModificacion === 4)

		setMueblesNuevos(mueblesNuevos)
		setDespliegueTipo("programar")

		if (mueblesNuevos.length > 0) {
			setIsPopupSolicitarTarifasQuestionOpen(true)
		} else {
			setIsPopupProgramarDespliegueOpen(true)
		}

		// setIsPopupProgramarDespliegueOpen(true)
	}

	const handleCancelQuestionSolicitarTarifa = () => {
		setIsPopupSolicitarTarifasQuestionOpen(false)
		setMueblesNuevos([])
		setSelectedProveedores([])

		if(despliegueTipo === "programar") {
			setIsPopupProgramarDespliegueOpen(true)
		}else {
			publicarMuebles(true)
		}
	
	}

	const handlePopupAcceptDespliegue = async () => {
		console.log("Scheduled Date:", scheduledDate)

		if (selectedMuebles.length === 0) {
			notificationRef.current.addNotification(
				"Selecciona al menos un mueble para programar.",
				"warning"
			)
			return
		}

		if (!scheduledDate.date || !scheduledDate.time) {
			notificationRef.current.addNotification(
				"Selecciona una fecha y hora para el despliegue.",
				"warning"
			)
			return
		}

		const fechaLocal = new Date(
			`${scheduledDate.date}T${scheduledDate.time}:00`
		)
		const fechaPublicacion = fechaLocal.toISOString()
		console.log("Fecha combinada UTC:", fechaPublicacion)

		const requestPublish = {
			codMuebles: selectedMuebles.flat(),
			codMueblesNuevos: mueblesNuevos.map((mueble) => mueble.codMueble),
			codsProveedor: selectedProveedores,
			plazo: plazo || 15,
			nombreTarifa: nombreTarifa
		}

		const requestBody = {
			publishRequest: requestPublish,
			fechaPublicacion: fechaPublicacion
		}

		console.log("Request Body:", requestBody)

		try {
			await api.post("/api/Mueble/ProgramarDespliegue", requestBody, {
				headers: {
					"Content-Type": "application/json"
				}
			})

			notificationRef.current.addNotification(
				"Despliegue programado exitosamente.",
				"success"
			)
			setIsPopupProgramarDespliegueOpen(false)
		} catch (error) {
			console.error("Error al programar despliegue:", error)
			notificationRef.current.addNotification(
				"Hubo un error al programar el despliegue.",
				"error"
			)
		}
	}

	return (
		<>
			<div className="dashboard-productos__content__table-header">
				<InputSearch
					context="tableSearch"
					placeholder="Buscar..."
					onSearch={setSearchTerm}
				/>
				<div className="dashboard-productos__content__table-header__buttons">
					<Button onClick={openModal} label="Filtros" icon={<FiFilter />} />
					<Button
						label="Programar despliegue"
						icon={<PiClock />}
						variant="outline"
						onClick={() => handleProgramarDespliegue()}
					/>
					<Button
						label="Desplegar versión"
						icon={<PiRocket />}
						variant="filled"
						onClick={handleDesplegarVersion}
					/>
				</div>
			</div>

			<Table
				columns={columnsConEstado}
				actions={actionsListoParaDesplegar}
				rowKey="codMueble"
				data={filteredMuebles}
				noResultsMessage="No se han encontrado resultados."
				selectableRows={true}
				selectedRows={selectedMuebles}
				onRowSelect={handleSelectMueble}
			/>

			<Modal
				title="Filtros"
				isOpen={isModalOpen}
				onClose={closeModal}
				onAccept={handleAcceptFilters}
				outlineButtonLabel="Limpiar"
				primaryButtonLabel={`Ver resultados (${filteredMuebles.length})`}
				onCancel={handleCleanFilter}
			>
				<div>
					<Accordion title="Variante">
						<ul className="section-header__modal__section__content">
							{variantes.map((familia, index) => (
								<Tag
									key={index}
									label={familia}
									isSelected={filterVariantes.includes(familia)}
									onSelect={handleSelectVariante}
								/>
							))}
						</ul>
					</Accordion>
				</div>
				<div className="section-header__modal__section">
					<Accordion title="Categoría">
						<ul className="section-header__modal__section__content">
							{categorias.map((categoria, index) => (
								<Tag
									key={index}
									label={categoria}
									isSelected={filterCategoria.includes(categoria)}
									onSelect={handleSelectCategoria}
								/>
							))}
						</ul>
					</Accordion>
				</div>
				<div className="section-header__modal__section">
					<Accordion title="Subcategoría">
						<ul className="section-header__modal__section__content">
							{subCategorias.map((subcategoria, index) => (
								<Tag
									key={index}
									label={subcategoria}
									isSelected={filterSubcategoria.includes(subcategoria)}
									onSelect={handleSelectSubcategoria}
								/>
							))}
						</ul>
					</Accordion>
				</div>
				<div className="section-header__modal__section">
					<Accordion title="Familia">
						<ul className="section-header__modal__section__content">
							{familias.map((familia, index) => (
								<Tag
									key={index}
									label={familia}
									isSelected={filterFamilia.includes(familia)}
									onSelect={handleSelectFamilia}
								/>
							))}
						</ul>
					</Accordion>
				</div>
				<div className="section-header__modal__section">
					<Accordion title="Estado">
						<ul className="section-header__modal__section__content">
							{estados.map((estado, index) => (
								<Tag
									key={index}
									label={estado}
									isSelected={filterEstado.includes(estado)}
									onSelect={handleSelectEstado}
								/>
							))}
						</ul>
					</Accordion>
				</div>
			</Modal>

			{isPopupSolicitarTarifasQuestionOpen && (
				<Popup
					titleMessage={"Solicitar tarifas"}
					type="alert"
					isOpen={isPopupSolicitarTarifasQuestionOpen}
					onConfirm={() => setIsPopupSolicitarTarifasOpen(true)}
					onClose={() => handleCancelQuestionSolicitarTarifa()}
					confirmLabel="Sí"
					cancelLabel="No"
					alertMessage={`Hay algún mueble nuevo, ¿Quieres solicitar las tarifas a los proveedores?`}
				/>
			)}

			{isPopupSolicitarTarifasOpen && (
				<Popup
					titleMessage={"Solicitar tarifa"}
					type="info"
					isOpen={isPopupSolicitarTarifasOpen}
					onConfirm={handleConfirmSolicitarTarifa}
					onClose={() => setIsPopupSolicitarTarifasOpen(false)}
					confirmLabel="Sí"
					cancelLabel="No"
					alertMessage={`¿Estás seguro de que quieres aceptar ${
						selectedMuebles.length
					} tarifa${selectedMuebles.length !== 1 ? "s" : ""}?`}
					children={
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "8px"
							}}
						>
							<h2 style={{ marginBottom: "16px" }}>
								Lista de proveedores disponibles:
							</h2>
							{proveedores.map((proveedor) => (
								<InputCheckbox
									key={proveedor.codEmpresa}
									label={proveedor.nombre}
									checked={selectedProveedores.includes(proveedor.codEmpresa)}
									onChange={() => handleProveedorChange(proveedor.codEmpresa)}
								/>
							))}
							<InputDropdownAdd
								options={tarifas}
								value={nombreTarifa}
								onSelect={(e) => handleSetNombreTarifa(e.value, "select")}
								onAddOption={(e) => handleSetNombreTarifa(e, "add")}
								placeholder="Nombre Tarifa"
								label="Nombre Tarifa"
							/>
							<Input
								key="plazo"
								label="Plazo de entrega (días)"
								type="number"
								value={plazo}
								onChange={(e) => setPlazo(e.target.value)}
							/>
						</div>
					}
				/>
			)}

			{isPopupProgramarDespliegueOpen && (
				<Popup
					type="info"
					titleMessage="Programar Despliegue"
					onConfirm={handlePopupAcceptDespliegue}
					onClose={() => setIsPopupProgramarDespliegueOpen(false)}
					confirmLabel="Aceptar"
					cancelLabel="Cancelar"
					children={
						<form className="gestion-muebles__modal__form">
							<div className="gestion-muebles__modal__form__input">
								<Calendar
									onDateChange={(date) => {
										console.log("onDateChange llamado con:", date)
										setScheduledDate((prev) => ({
											...prev,
											date
										}))
									}}
									onTimeChange={(time) => {
										console.log("onTimeChange llamado con:", time)
										setScheduledDate((prev) => ({
											...prev,
											time
										}))
									}}
								/>
							</div>
						</form>
					}
				/>
			)}

			<Notification ref={notificationRef} />
		</>
	)
}
